<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal success_popup" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <!-- <div class="modal_close_btn">
        <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
      </div> -->
      <!-- Modal content-->
      <div mat-dialog-content>
        <!-- Modal-Body -->
        <div class="modal-body br-8">
          <div class="modal_close_btn">
            <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
          </div>
          <div class="success_details">
            <div class="status_img">
              <img src="../../../../../assets/images/icons/success.svg" alt="" loading="eager">
            </div>
            <!-- For SUPPLIER -->
            <div class="status_content" *ngIf="data?.type === 'SUPPLIER'; else nonSupplierContent">
              <h4>Thank you for your interest!</h4>
              <p> Our team will be in touch with you shortly.
              </p>
            </div>

            <!-- For Other Types -->
            <ng-template #nonSupplierContent>
              <div class="status_content">
                <h4>Thank you for registering!</h4>
                <p> A verification email has been sent to
                  <span>{{data?.email}}</span>. Please verify your email to activate your account.
                </p>
                <!-- <p>A verification link has been sent to <span>{{data?.email}}</span>.  
      Please click on the link to activate your account and get started.
    </p> -->
              </div>
            </ng-template>


          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer" style="text-align: center; margin-top: 16px;justify-content: center;">
          <button mat-button color="primary" class="orange-btn" (click)="logIn()">Done</button>
        </div>
      </div>
    </div>
  </div>
</div>